/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable no-plusplus */
import React from 'react';
import {get, size} from 'lodash';
import {I18n} from 'react-redux-i18n';
import Icon from '@material-ui/core/Icon';
import PropTypes from 'prop-types';
import {STANDARD_DVR_CAMERAS, TWO_CHANNEL_DVR_CAMERAS, ADPLUS2_DVR_CAMERAS} from '../../util';
import playBtnUrl from './images/play-bt.png';
import cameraBtnUrl from './images/camera-bt.png';


export default class VideoCardThumb extends React.PureComponent {
  static propTypes = {
    machineType: PropTypes.number,
    isMobile: PropTypes.bool,
    mediaId: PropTypes.string.isRequired,
    source: PropTypes.string.isRequired,
    availableCameras: PropTypes.shape({}),
    onClick: PropTypes.func.isRequired,
    locale: PropTypes.string
  };
  static defaultProps = {
    locale: 'en',
    machineType: 0,
    isMobile: false,
    availableCameras: {1: true}
  }
  state = {
    hover: false
  }

  handleMouseEnter = () => this.setState({hover: true})
  handleMouseLeave = () => this.setState({hover: false})
  handleClick = () => this.props.onClick();
  handleCameraClick = camera => e => {
    e.stopPropagation();
    this.props.onClick(camera);
  }

  isTwoChannelDvr() {
    return this.props.machineType === 1;
  }

  renderDefault = () => {
    return (
      <div className="videothumb__container video-out">
        <div className="videothumb__playbtcont">
          <img src={playBtnUrl} alt="" className="videothumb__playbt" id={`videoCardPlay-${this.props.mediaId}`} />
        </div>
        <img src={this.props.source} alt="" className="videothumb__thumb" id={`videoCardThumb-${this.props.mediaId}`} />
      </div>
    );
  }

  renderMulticam = camerasAmount => {
    let linkName = 'split-camera';

    const hasSplitCamera = get(this.props.availableCameras, 99, false);

    if (!hasSplitCamera) {
      linkName = this.getCameraData(1).linkName;
    }

    return (
      <div className={`videothumb__container ${this.state.hover ? 'video-hover' : 'video-out'}`}>
        <div className="videothumb__playbtcont">
          <button onClick={this.handleCameraClick(linkName)} id={`videoCardSplitView-${this.props.mediaId}`}>
            <label>{camerasAmount}</label>
            <img alt="" src={cameraBtnUrl} className="videothumb__playbt" id={`videoCardThumb-${this.props.mediaId}`} />
          </button>
          {this.renderCameraLink(1)}
          {this.renderCameraLink(3)}
          {this.renderCameraLink(4)}
          {this.renderCameraLink(2)}
        </div>
        <img alt="" src={this.props.source} className="videothumb__thumb" />
      </div>
    );
  }

  getCameraData = channel => {
    let cameras = STANDARD_DVR_CAMERAS;
    if(this.props.machineType === 4){
      cameras = ADPLUS2_DVR_CAMERAS;
    }
    if (this.isTwoChannelDvr()) {
      cameras = TWO_CHANNEL_DVR_CAMERAS;
    }
    let cameraChannel = null;
    cameras && Object.keys(cameras).forEach((key) => {
      if(cameras[key].channelIndex == channel){
        cameraChannel = cameras[key];
      }
    });
    return cameraChannel;
  }

  renderCameraLink = channel => {
    const showIcon = get(this.props.availableCameras, channel, false);
    if (!showIcon) {
      return null;
    }

    const camera = this.getCameraData(channel);
    if (!camera) {
      return null;
    }

    return (
      <button
        onClick={this.handleCameraClick(camera.linkName)}
        className={`videothumb__playcircle ${camera.key}-cam`}
        id={`videoCardCamera${camera.key}-${this.props.mediaId}`}
      >
        {camera.textBeforeIcon && I18n.t(`page.library.video.camera.${camera.key}`)}
        <Icon className="videothumb__camview">
          {`arrow_${camera.arrowDirection}`}
        </Icon>
        {!camera.textBeforeIcon && I18n.t(`page.library.video.camera.${camera.key}`)}
      </button>
    );
  }

  renderThumb = () => {
    if (this.props.isMobile) {
      return this.renderDefault();
    }

    const availableCameras = get(this.props, 'availableCameras', {});
    let countCameras = size(availableCameras);

    if (availableCameras[99]) {
      countCameras--;
    }

    if (countCameras > 1) {
      return this.renderMulticam(countCameras);
    }

    return this.renderDefault();
  }

  render() {
    return (
      <div
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        onClick={this.handleClick}
      >
        {this.renderThumb()}
      </div>
    );
  }
}
